<script setup lang="ts">
import type { AppTextareaEvent, NativeSelectOption } from '@shared/ui/fields'

import { AppText } from '@shared/ui/typography'
import { AppTextarea, NativeSelect } from '@shared/ui/fields'

defineOptions({
  name: 'LessonReassignReason',
})

withDefaults(defineProps<{
  options: NativeSelectOption[]
  reason: string | null
  comment: string
  invalid?: boolean
  disabled?: boolean
}>(), {
  invalid: false,
  disabled: false,
})

const emit = defineEmits<{
  'change:reason': [option: NativeSelectOption]
  'change:comment': [event: AppTextareaEvent]
}>()
</script>

<template>
  <div class="lesson-reassign-reason">
    <div class="lesson-reassign-reason__notice">
      <AppText
        name="body2"
        color="slate-900"
      >
        After you confirm this action, both the previous tutor and the chosen tutor will be notified about the changes.
      </AppText>
      <AppText
        name="body2"
        color="slate-900"
      >
        This action cannot be undone.
      </AppText>
    </div>
    <NativeSelect
      name="tutor_reassign_reason"
      label="Tutor change reason"
      :options="options"
      :value="reason"
      :mode="invalid ? 'error' : 'normal'"
      :disabled="disabled"
      required
      @change="option => emit('change:reason', option)"
    />
    <AppTextarea
      name="tutor_reassign_comment"
      label="Comment"
      placeholder="Type here"
      :value="comment"
      :disabled="disabled"
      @input="event => emit('change:comment', event)"
    />
  </div>
</template>

<style scoped lang="scss" src="./LessonReassignReason.scss" />
